import { useQuery } from '@tanstack/react-query';
import { type Ricerca, type RigaAnagrafica, RICERCA_INIZIALE } from './anagrafiche.js';
import { RICERCA_ARTICOLI, type RigaArticolo } from './articoli.js';
import { chiama } from './cliente.js';
import { RICERCA_ORDINI, type RigaOrdine } from './ordini.js';

/**
 * La ricerca della barra in alto: ordini, clienti e articoli insieme.
 *
 * Non ha una rotta sua: chiede le prime righe agli stessi elenchi che si
 * aprono dal menu, con la stessa ricerca. Così trova esattamente quello che
 * troverebbe l'elenco, e «Vedi tutti» porta a un elenco che dice la stessa
 * cosa.
 */
export const QUANTI = 5;

function parametri(r: Ricerca, extra: Record<string, string> = {}) {
  return new URLSearchParams({
    page: '1',
    size: String(QUANTI),
    sort: r.sort,
    dir: r.dir,
    q: r.q,
    ...extra,
  }).toString();
}

export function useRicercaRapida(
  testo: string,
  sezioni: { ordini: boolean; clienti: boolean; articoli: boolean },
) {
  const attiva = testo.length >= 2;

  const ordini = useQuery({
    queryKey: ['ricerca-rapida', 'ordini', testo],
    queryFn: () =>
      chiama<{ rows: RigaOrdine[]; total: number }>(
        `/api/orders?${parametri({ ...RICERCA_ORDINI, q: testo })}`,
      ),
    enabled: attiva && sezioni.ordini,
  });
  const clienti = useQuery({
    queryKey: ['ricerca-rapida', 'clienti', testo],
    queryFn: () =>
      chiama<{ rows: RigaAnagrafica[]; total: number }>(
        `/api/identities?${parametri({ ...RICERCA_INIZIALE, q: testo }, { type: 'customer' })}`,
      ),
    enabled: attiva && sezioni.clienti,
  });
  const articoli = useQuery({
    queryKey: ['ricerca-rapida', 'articoli', testo],
    queryFn: () =>
      chiama<{ rows: RigaArticolo[]; total: number }>(
        `/api/items?${parametri({ ...RICERCA_ARTICOLI, q: testo })}`,
      ),
    enabled: attiva && sezioni.articoli,
  });

  return { attiva, ordini, clienti, articoli };
}
